import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-transfer', en)

export * from './src/components'
export * from './src/constants'
export * from './src/context'
export * from './src/hooks'
export * from './src/pages/account-transfer/account-transfer'
export * from './src/pages/bank-transfer/bank-transfer'
export * from './src/pages/default'
export * from './src/pages/rollover-ira-info'
export * from './src/pages/tabbed-wire-transfer/tabbed-wire-transfer'
export * from './src/pages/transfer'
export * from './src/pages/transfer-landing-page'
export * from './src/pages/wires'
export * from './src/pages/wires/wires-review/wires-review'
export * from './src/pages/wires/wires-success/wires-success'
export * from './src/types'
export * from './src/pages/joint-account-transfer-review'
